(()=>{
  if(location.pathname!=='/pages/pernoctar') return;
  const SB='https://ouhtkmpgsmauyebwpqsj.supabase.co';
  const KEY='sb_publishable_CBwe_LRkZmEii18EiiUtuA_uxonULzb';
  const H={apikey:KEY,Authorization:`Bearer ${KEY}`};
  const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  const esc=s=>String(s||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  let all=[],ctx=null,shown=48,active=false,filter='Todos';

  function score(d){
    if(!ctx)return 9;
    if(ctx.municipio&&norm(d.municipio)===norm(ctx.municipio))return 0;
    if(ctx.provincia&&norm(d.provincia)===norm(ctx.provincia))return 1;
    if(ctx.comunidad_autonoma&&norm(d.comunidad_autonoma)===norm(ctx.comunidad_autonoma))return 2;
    return 9;
  }
  function contextFrom(raw){
    const n=norm(raw); if(!n)return null;
    let x=all.find(d=>norm(d.municipio)===n||norm(d.slug)===n);
    if(x)return x;
    x=all.find(d=>norm(d.provincia)===n);
    if(x)return {provincia:x.provincia,comunidad_autonoma:x.comunidad_autonoma};
    x=all.find(d=>norm(d.comunidad_autonoma)===n);
    if(x)return {comunidad_autonoma:x.comunidad_autonoma};
    x=all.find(d=>norm(d.municipio).includes(n)||n.includes(norm(d.municipio)));
    return x||null;
  }
  function render(){
    const root=document.querySelector('#cv-global-destinations .cvdc'); if(!root||!active)return;
    const track=root.querySelector('[data-track]'),count=root.querySelector('[data-count]'); if(!track)return;
    let list=all.filter(d=>filter==='Todos'||String(d.comunidad_autonoma||'').includes(filter));
    list=[...list].sort((a,b)=>score(a)-score(b)||String(a.municipio||'').localeCompare(String(b.municipio||''),'es'));
    const view=list.slice(0,shown);
    track.innerHTML=view.map(d=>{const u='/apps/pernoctar/guia-'+encodeURIComponent(d.slug||d.municipio||'');return `<article class="cvdc-card"><img loading="lazy" src="${esc(d.cover_image_url)}" alt="${esc(d.municipio)}"><a class="cvdc-card__guide" href="${u}" aria-label="Abrir guía de ${esc(d.municipio)}"></a>${d.cover_image_source?`<a class="cvdc-credit" href="${esc(d.cover_image_source)}" target="_blank" rel="noopener" onclick="event.stopPropagation()">Foto · Commons</a>`:''}<div class="cvdc-card__text"><small>${esc(d.provincia||d.comunidad_autonoma||'ESPAÑA')}</small><h3>${esc(d.municipio)}</h3><p><a href="${u}">Descubrir</a> · <a href="/pages/pernoctar?q=${encodeURIComponent(d.municipio)}">Dónde dormir</a></p></div></article>`}).join('');
    if(count)count.textContent=`${view.length} de ${list.length} destinos con fotografía`;
    const more=root.querySelector('[data-more]'); if(more)more.hidden=view.length>=list.length;
    track.scrollTo({left:0,behavior:'smooth'});
  }
  function apply(raw){
    const c=contextFrom(raw); if(!c)return;
    ctx=c; active=true; shown=48; filter='Todos';
    const root=document.querySelector('#cv-global-destinations .cvdc');
    root?.querySelectorAll('[data-filter]').forEach(b=>b.classList.toggle('active',b.dataset.filter==='Todos'));
    render();
  }
  async function load(){
    let rows=[];
    for(let from=0;from<5000;from+=1000){
      const r=await fetch(`${SB}/rest/v1/destinations?select=slug,municipio,provincia,comunidad_autonoma,cover_image_url,cover_image_source&published=eq.true&cover_image_url=not.eq.__NO_IMAGE__&order=municipio.asc&offset=${from}&limit=1000`,{headers:H});
      if(!r.ok)break; const b=await r.json(); rows=rows.concat(b); if(b.length<1000)break;
    }
    all=rows.filter(x=>/^https?:/.test(x.cover_image_url||''));
    const q=new URLSearchParams(location.search).get('q'); if(q)apply(q);
  }
  document.addEventListener('DOMContentLoaded',()=>{
    load().catch(()=>{});
    const input=document.getElementById('cvgSearch'),go=document.getElementById('cvgSearchGo');
    const sync=()=>setTimeout(()=>apply(input?.value||''),700);
    input?.addEventListener('keydown',e=>{if(e.key==='Enter')sync()});
    input?.addEventListener('search',sync);
    go?.addEventListener('click',sync);

    const root=document.querySelector('#cv-global-destinations .cvdc');
    root?.addEventListener('click',e=>{
      if(!active)return;
      const btn=e.target.closest('button'); if(!btn)return;
      if(btn.matches('[data-more]')){e.preventDefault();e.stopImmediatePropagation();shown+=48;render();return;}
      if(btn.matches('[data-filter]')){e.preventDefault();e.stopImmediatePropagation();filter=btn.dataset.filter||'Todos';shown=48;root.querySelectorAll('[data-filter]').forEach(x=>x.classList.toggle('active',x===btn));render();return;}
      const track=root.querySelector('[data-track]');
      if(btn.matches('[data-prev]')){e.preventDefault();e.stopImmediatePropagation();track?.scrollBy({left:-588,behavior:'smooth'});}
      if(btn.matches('[data-next]')){e.preventDefault();e.stopImmediatePropagation();track?.scrollBy({left:588,behavior:'smooth'});}
    },true);
  });
})();